const TOKEN_ENDPOINT = '/api/tracks/token';
const HEARTBEAT_ENDPOINT = '/api/tracks/heartbeat';

const JSON_HEADERS = { 'Content-Type': 'application/json' };

export class StreamTokenService {
    private abortController: AbortController | null = null;

    async fetchToken(trackId: number): Promise<string> {
        this.abortController?.abort();
        this.abortController = new AbortController();

        const response = await fetch(TOKEN_ENDPOINT, {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify({ trackId }),
            signal: this.abortController.signal,
        });

        if (!response.ok) {
            throw new Error(`Token request failed with status ${response.status}`);
        }

        const data = await response.json();
        return data.token;
    }

    reportHeartbeat(token: string, position: number): void {
        fetch(HEARTBEAT_ENDPOINT, {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify({ token, position: Math.floor(position) }),
        }).catch(() => {});
    }

    cancelPending(): void {
        this.abortController?.abort();
        this.abortController = null;
    }
}
